// src/pages/MusicTasksList.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebaseConfig";

import MusicTaskItem from "../components/MusicTaskItem";

export default function MusicTasksList() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const cargar = async () => {
      try {
        setLoading(true);
        setError("");

        const qRef = query(
          collection(db, "musicTasks"),
          orderBy("createdAt", "desc")
        );

        const snap = await getDocs(qRef);

        const lista = snap.docs.map((docSnap) => {
          const data = docSnap.data() || {};
          return {
            id: docSnap.id,
            createdAt: data.createdAt?.toDate?.() || null,
            idCancion: data.idcancion || data.idCancion || "",
            idUser: data.iduser || data.idUser || "",
            mode: data.mode || "",
          };
        });

        setTasks(lista);
      } catch (err) {
        console.error(err);
        setError(err?.message || "Error cargando musicTasks");
      } finally {
        setLoading(false);
      }
    };

    cargar();
  }, []);

  const filtered = useMemo(() => {
    const s = search.trim().toLowerCase();
    if (!s) return tasks;
    return tasks.filter((t) => {
      const id = (t.id || "").toLowerCase();
      const idCancion = (t.idCancion || "").toLowerCase();
      const idUser = (t.idUser || "").toLowerCase();
      const mode = (t.mode || "").toLowerCase();
      return (
        id.includes(s) ||
        idCancion.includes(s) ||
        idUser.includes(s) ||
        mode.includes(s)
      );
    });
  }, [tasks, search]);

  const handleOpen = (task) => {
    // Si luego haces detalle, puedes navegar a /music-tasks/:id
    // navigate(`/music-tasks/${task.id}`);
    // Por ahora: solo lo dejamos listo para navegar.
    console.log("open task", task.id);
  };

  return (
    <div style={{ padding: 18, maxWidth: 980, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
        <h2 style={{ margin: 0 }}>Music Tasks</h2>
        <button
          onClick={() => navigate(-1)}
          style={{
            borderRadius: 10,
            border: "1px solid rgba(0,0,0,.15)",
            padding: "8px 12px",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          Volver
        </button>
      </div>

      <div style={{ marginTop: 12, display: "flex", gap: 10, flexWrap: "wrap" }}>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar por id, idCancion, idUser o mode..."
          style={{
            flex: 1,
            minWidth: 260,
            padding: "10px 12px",
            borderRadius: 10,
            border: "1px solid rgba(0,0,0,.15)",
            outline: "none",
          }}
        />
        <div style={{ opacity: 0.75, paddingTop: 10 }}>
          Total: <b>{filtered.length}</b>
        </div>
      </div>

      {loading && <div style={{ marginTop: 14 }}>Cargando...</div>}
      {error && (
        <div style={{ marginTop: 14, color: "crimson" }}>
          Error: {error}
        </div>
      )}

      {!loading && !error && (
        <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
          {filtered.map((t) => (
            <MusicTaskItem key={t.id} task={t} onOpen={handleOpen} />
          ))}
          {!filtered.length && (
            <div style={{ opacity: 0.75 }}>No hay musicTasks.</div>
          )}
        </div>
      )}
    </div>
  );
}